import AsyncSelect from "react-select/async";
import { FC } from "react";
import { gql, useLazyQuery } from "@apollo/client";

const SEARCH_PRODUCTS = gql`
  query SearchProducts($search: String!, $first: Int!) {
    products(search: $search, first: $first) {
      edges {
        node {
          dbId
          name
        }
      }
    }
  }
`;

interface ProductChooserProps {
    fieldLabel: string;
    fieldSchema?: { description?: string };
    isMulti?: boolean;
    defaultOptions?: any[];
    value: any;
    onChange: (selected: any) => void;
    [key: string]: any;
}

const ProductChooser: FC<ProductChooserProps> = ({
    fieldLabel,
    fieldSchema,
    isMulti = false,
    defaultOptions = [],
    value,
    onChange,
    ...commonProps
}) => {
    const [searchProducts] = useLazyQuery(SEARCH_PRODUCTS);

    const loadOptions = async (inputValue: string) => {
        try {
            const { data } = await searchProducts({
                variables: { 
                    search: inputValue || "",
                    first: 10
                }
            });

            if (!data?.products?.edges) {
                return [];
            }

            return data.products.edges.map((edge: any) => ({
                value: edge.node.dbId,
                label: edge.node.name
            }));
        } catch (error) {
            console.error('Error loading products:', error);
            return [];
        }
    };

    return (
        <div {...commonProps}>
            <label className="block text-sm font-medium text-gray-700 mb-1">
                {fieldLabel}
            </label>
            <AsyncSelect
                isMulti={isMulti}
                cacheOptions
                defaultOptions={[]}
                value={value || []}
                onChange={onChange}
                loadOptions={loadOptions}
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Search products..."
                noOptionsMessage={() => "No products found"}
                loadingMessage={() => "Loading products..."}
                menuPortalTarget={document.body}
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                    })
                }}
            />
            {fieldSchema?.description && (
                <p className="mt-1 text-sm text-gray-500">{fieldSchema.description}</p>
            )}
        </div>
    );
};

export default ProductChooser;
